import { authListClientEffects } from "./auth/auth-list-client.effects";
import { authEffects } from "./auth/auth.effects";
import { EssentialsEffects } from "./essentials/essentials.effects";

export const EffectsArray: any[] = [authEffects,authListClientEffects,EssentialsEffects]